import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import AboutPage from '../../pages/AboutPage';
import HomePage from '../../pages/HomePage';
import Login from '../../pages/Login/index';
import ForgotPassword from '../../pages/ForgotPassword';

import ListProfiles from '../../pages/ListProfiles/index';
import ListDenunciations from '../../pages/ListDenunciations';

import AdminProfile from '../../pages/Admin/Profile/index';
import CreateOuvidoria from '../../pages/Admin/CreateOuvidoria/index';


export default function Routes(){
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={HomePage}/>
                <Route path='/about' component={AboutPage}/>
                <Route path='/login' component={Login}/>
                <Route path='/forgot-password' component={ForgotPassword}/>
                
                <Route path='/list-profiles' component={ListProfiles}/>
                <Route path='/list-denunciations' component={ListDenunciations}/>

                <Route path='/admin-profile' component={AdminProfile}/>
                <Route path='/create-ouvidoria' component={CreateOuvidoria}/>

            </Switch>
        </BrowserRouter>
    )
}